// TODO: combine with emailPreference reducer
export default function userSelections(state = {}, action) {
  switch (action.type) {
    case 'USER_SET_SHIPPING_OPTION': {
      return { ...state, userSelectedShippingOption: true }
    }

    case 'UNSET_SHIPPING_OPTION': {
      return { ...state, userSelectedShippingOption: false }
    }

    default: {
      return state
    }
  }
}
